import { SolicitacaoFiscalizacao } from "./SolicitacaoFiscalizacao";

export default SolicitacaoFiscalizacao;